module.exports = __webpack_public_path__ + "files/6a37b8ce3d8c04e39eae6a560e6cdb87.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-2.png
// module id = 526
// module chunks = 76